<template>
  <span class="svg-icon-achievment-v52">
    <svg class="icon-color-1" :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4421 12.7469H6.34739L9.2058 21.5176C9.33415 21.9114 9.11893 22.3347 8.72511 22.4631C8.33128 22.5914 7.90797 22.3762 7.77962 21.9824L2.60419 6.10212C2.02497 4.32484 3.34955 2.5 5.21884 2.5H13.4164C14.659 2.5 15.6664 3.50736 15.6664 4.75V6.76301H21.7127C21.9601 6.76301 22.1917 6.88508 22.3315 7.08927C22.4713 7.29345 22.5014 7.55346 22.4119 7.78419L20.8222 11.8833L22.4042 15.6513C22.5014 15.8829 22.4763 16.1477 22.3372 16.3568C22.1982 16.566 21.9638 16.6916 21.7127 16.6916H11.1921C10.7779 16.6916 10.4421 16.3559 10.4421 15.9416V12.7469ZM4.03036 5.63733C3.76708 4.82947 4.36916 4 5.21884 4H13.4164C13.8306 4 14.1664 4.33579 14.1664 4.75V10.4969C14.1664 10.9111 13.8306 11.2469 13.4164 11.2469H5.85853L4.03036 5.63733ZM11.9421 12.7469V15.1916H20.5844L19.322 12.1847C19.2468 12.0056 19.244 11.8043 19.3142 11.6232L20.6174 8.26301H15.6664V10.4969C15.6664 11.7395 14.659 12.7469 13.4164 12.7469H11.9421Z" :fill="color"/>
    </svg>
  </span>

</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } }
  }
}
</script>
